export default defineNuxtRouteMiddleware((to) => {
  const authStore = useAuthStore()
  const localePath = useLocalePath()

  // Check if user is authenticated
  if (!authStore.token || !authStore.user) {
    // Redirect to auth redirect page with return URL
    return navigateTo(
      localePath({
        name: 'auth-redirect',
        query: {
          redirect: to.fullPath
        }
      })
    )
  }
})
